import { render, staticRenderFns } from "./SectionCategoriesMenu.vue?vue&type=template&id=624eee01&scoped=true&"
import script from "./SectionCategoriesMenu.vue?vue&type=script&lang=ts&"
export * from "./SectionCategoriesMenu.vue?vue&type=script&lang=ts&"
import style0 from "./SectionCategoriesMenu.vue?vue&type=style&index=0&id=624eee01&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624eee01",
  null
  
)

export default component.exports